module.exports = require("./fr-GN");